import React, { useState } from 'react';

import Riva from '../../assets/logos/podeMorar/Riva.svg';
import Direcional from '../../assets/logos/podeMorar/Direcional.png';

import { ReactSVG } from 'react-svg';

import portalEnvironment from '../../Utils/baseURL';

import './styles.scss';

const LogoDirecionalRiva = () => {
  const [mostraAmbiente, setMostraAmbiente] = useState(false);

  function showAmbient() {
    if (portalEnvironment.environment !== 'Prod') {
      setMostraAmbiente(true);
      setTimeout(function () {
        setMostraAmbiente(false);
      }, 3000);
    }
  }

  return (
    <>
      {!mostraAmbiente && (
        <div
          onClick={(event) => {
            event.preventDefault();

            showAmbient();
          }}
          className='logoHomeDirecionalRiva centralized-space-between'
          style={{
            width: '100%',
            gap: 24,
            justifyContent: 'center',
          }}
        >
          <img src={Direcional} alt='' />

          <ReactSVG src={Riva} />
        </div>
      )}

      {portalEnvironment.environment !== 'Prod' && mostraAmbiente && (
        <span>Você está no ambiente de: {portalEnvironment.environment}</span>
      )}
    </>
  );
};

export default LogoDirecionalRiva;
